import Icon from "@mui/material/Icon";
import Login from "@mui/icons-material/Login";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import TrainerSignIn from "layouts/pages/authentication/TrainerSign-in/TrainerSign-in";
import TrainingCompanySignIn from "layouts/pages/authentication/TrainingCompanySign-in/TrainingCompanySign-in";
import TrainingIndex from ".//pages/LandingPages/TrainingList/TrainingListIndex";
import TrainerIndex from ".//pages/LandingPages/TrainerList/TrainerListIndex";

const routes = [
  {
    name: "Trainings",
    icon: <Icon>view_day</Icon>,
    route: "/app/traininglistindex",
    component: <TrainingIndex />,
  },
  {
    name: "Trainers",
    icon: <AccountBoxIcon />,
    route: "/app/trainerlistindex",
    component: <TrainerIndex />,
  },
  {
    name: "Login",
    icon: <Login />,
    collapse: [
      {
        name: "Trainer",
        description: "Login as Trainer",
        route: "/pages/authentication/trainersign-in",
        component: <TrainerSignIn />,
      },
      {
        name: "Training Partner",
        description: "Login as Training Partner",
        route: "/pages/authentication/trainingcompanysign-in",
        component: <TrainingCompanySignIn />,
      },
    ],
  },
];

export default routes;
